import { CategoryModel, IEcwidImageUpload, IUpsertCategoryPayload } from '@boxx/store-core';
import { createAction, props } from '@ngrx/store';
import { EcwidImageModel } from '../../models/EcwidImage.model';

export enum StoreCategoriesActionTypes {
  loadCategoriesBegin = '[STORE] Load Categories Begin',
  loadCategoriesSuccess = '[STORE] Load Categories Success',
  loadCategoriesFail = '[STORE] Load Categories Fail',

  loadCategoryByIdBegin = '[STORE] Load Category By Id Begin',
  loadCategoryByIdSuccess = '[STORE] Load Categorie By Id Success',
  loadCategoryByIdFail = '[STORE] Load Categorie By Id Fail',

  createCategoryBegin = '[STORE] Create Category Begin',
  createCategorySuccess = '[STORE] Create Category Success',
  createCategoryFail = '[STORE] Create Category Fail',

  updateCategoryBegin = '[STORE] Update Category Begin',
  updateCategorySuccess = '[STORE] Update Category Success',
  updateCategoryFail = '[STORE] Update Category Fail',

  deleteCategoryBegin = '[STORE] Delete Category Begin',
  deleteCategorySuccess = '[STORE] Delete Category Success',
  deleteCategoryFail = '[STORE] Delete Category Fail',

  uploadImageCategoryBegin = '[STORE] Upload Image Category Begin',
  uploadImageCategorySuccess = '[STORE] Upload Image Category Success',
  uploadImageCategoryFail = '[STORE] Upload Image Category Fail',

  deleteImageCategoryBegin = '[STORE] Delete Image Category Begin',
  deleteImageCategorySuccess = '[STORE] Delete Image Category Success',
  deleteImageCategoryFail = '[STORE] Delete Image Category Fail',

  loadImageCategoryUploadedBegin = '[STORE] Load Image Category Uploaded Begin',
  loadImageCategoryUploadedSuccess = '[STORE] Load Image Category Uploaded Success',
  loadImageCategoryUploadedFail = '[STORE] Load Image Category Uploaded Fail',

  clearCategoriesSuccessErrorData = '[STORE] Clear Categories Success/Error Data',
}

export const loadCategoriesBeginAction = createAction(
  StoreCategoriesActionTypes.loadCategoriesBegin
);

export const loadCategoriesSuccessAction = createAction(
  StoreCategoriesActionTypes.loadCategoriesSuccess,
  props<{ payload: CategoryModel[] }>()
);

export const loadCategoriesFailAction = createAction(
  StoreCategoriesActionTypes.loadCategoriesFail,
  props<{ errors: any }>()
);

export const loadCategorieByIdBeginAction = createAction(
  StoreCategoriesActionTypes.loadCategoryByIdBegin,
  props<{ id: number }>()
);

export const loadCategorieByIdSuccessAction = createAction(
  StoreCategoriesActionTypes.loadCategoryByIdSuccess,
  props<{ payload: CategoryModel }>()
);

export const loadCategorieByIdFailAction = createAction(
  StoreCategoriesActionTypes.loadCategoryByIdFail,
  props<{ errors: any }>()
);

export const createCategoryBeginAction = createAction(
  StoreCategoriesActionTypes.createCategoryBegin,
  props<{ payload: IUpsertCategoryPayload }>()
);

export const createCategorySuccessAction = createAction(
  StoreCategoriesActionTypes.createCategorySuccess,
  props<{ payload: CategoryModel[] }>()
);

export const createCategoryFailAction = createAction(
  StoreCategoriesActionTypes.createCategoryFail,
  props<{ errors: any }>()
);

export const updateCategoryBeginAction = createAction(
  StoreCategoriesActionTypes.updateCategoryBegin,
  props<{ payload: IUpsertCategoryPayload }>()
);

export const updateCategorySuccessAction = createAction(
  StoreCategoriesActionTypes.updateCategorySuccess,
  props<{ payload: CategoryModel }>()
);

export const updateCategoryFailAction = createAction(
  StoreCategoriesActionTypes.updateCategoryFail,
  props<{ errors: any }>()
);

export const deleteCategoryBeginAction = createAction(
  StoreCategoriesActionTypes.deleteCategoryBegin,
  props<{ id: number }>()
);

export const deleteCategorySuccessAction = createAction(
  StoreCategoriesActionTypes.deleteCategorySuccess,
  props<{ payload: CategoryModel[] }>()
);

export const deleteCategoryFailAction = createAction(
  StoreCategoriesActionTypes.deleteCategoryFail,
  props<{ errors: any }>()
);

export const uploadImageCategoryBeginAction = createAction(
  StoreCategoriesActionTypes.uploadImageCategoryBegin,
  // eslint-disable-next-line @typescript-eslint/member-delimiter-style
  props<{ id: number, file: string }>()
);

export const uploadImageCategorySuccessAction = createAction(
  StoreCategoriesActionTypes.uploadImageCategorySuccess,
  props<{ payload: EcwidImageModel }>()
);

export const uploadImageCategoryFailAction = createAction(
  StoreCategoriesActionTypes.uploadImageCategoryFail,
  props<{ errors: any }>()
);

export const clearCategoriesSuccessErrorDataAction = createAction(
  StoreCategoriesActionTypes.clearCategoriesSuccessErrorData
);

export const deleteImageCategoryBeginAction = createAction(
  StoreCategoriesActionTypes.deleteImageCategoryBegin,
  props<{ id: number }>()
);

export const deleteImageCategorySuccessAction = createAction(
  StoreCategoriesActionTypes.deleteImageCategorySuccess,
  props<{ payload: CategoryModel }>()
);

export const deleteImageCategoryFailAction = createAction(
  StoreCategoriesActionTypes.deleteImageCategoryFail,
  props<{ errors: any }>()
);

export const loadImageCategoryUploadedBeginAction = createAction(
  StoreCategoriesActionTypes.loadImageCategoryUploadedBegin,
  props<{ id: number }>()
);

export const loadImageCategoryUploadedSuccessAction = createAction(
  StoreCategoriesActionTypes.loadImageCategoryUploadedSuccess,
  props<{ payload: any }>()
);

export const loadImageCategoryUploadedFailAction = createAction(
  StoreCategoriesActionTypes.loadImageCategoryUploadedFail,
  props<{ errors: any }>()
);
